import React, { FunctionComponent } from 'react';
import {
  BodySM,
  BodyXS,
  BodyXXS,
  BodyXXXS,
  Caption,
  Emphasis,
  ErrorBody,
  Heading,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  LargeTitle,
  Title,
} from '../styles/Typography';
import { DemoComponent, DemoContainer, DemoHeader } from './Demo';

// Demonstration of lowest level typography components
export const DemoTypography: FunctionComponent = () => {
  return (
    <DemoContainer>
      <DemoComponent>
        <DemoHeader>Typography</DemoHeader>
        <Heading1>Heading 1</Heading1>
        <Heading2>Heading 2</Heading2>
        <Heading3>Heading 3</Heading3>
        <Heading4>Heading 4</Heading4>
        <Heading5>Heading 5</Heading5>
        <BodySM>Body 1 SM</BodySM>
        <BodySM bold> Bold Body 1 SM</BodySM>
        <BodyXXS>Body 2 XXS</BodyXXS>
        <BodyXXXS>Body 3 XXXS</BodyXXXS>
        <Caption>Caption</Caption>
        <Title>Title</Title>
        <LargeTitle>Large Title</LargeTitle>
      </DemoComponent>
      <DemoComponent>
        <DemoHeader>Text</DemoHeader>
        <BodyXS>
          BodyXS: Paragraph text. <Emphasis>Emphasis</Emphasis>
        </BodyXS>
        <ErrorBody>ErrorBody</ErrorBody>
        <Heading>Heading</Heading>
      </DemoComponent>
      ;
    </DemoContainer>
  );
};
